module.exports = __webpack_public_path__ + "static/media/wohnbau.32344edb.jpg";